// extracted by mini-css-extract-plugin
export default {"controlsButton":"styles_controlsButton__QU+Wb","editIcon":"styles_editIcon__Cqnyg"};